export default __webpack_public_path__ + "static/media/up-and-down-arrows.50b53faa.svg";